import _ from '@lodash';
import { AppBar, DialogContent, IconButton, Input, Paper, Toolbar, Typography, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as FuseActions from 'app/store/actions';
import clsx from 'clsx';
import React from 'react';
import history from "history.js";
import { MdClose } from 'react-icons/md';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import { bindActionCreators } from 'redux';
import XAPPDialog from '../Dialog/XAPPDialog';

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
        '& select, input': {
            backgroundColor: theme.palette.background.paper + " !important"
        }
    },
    divSelect: {
        borderRadius: 4,
        '&:hover': {
            backgroundColor: theme.palette.type === "dark" ? "rgb(255, 255, 255, .1)" : "rgb(0, 0, 0, .08)"
        }
    },
    textField: {
        color: "#333 !important",
        '&:before': {
            "border-bottom-style": "none !important"
        },
        '& #select-empresa': {
            cursor: "pointer !important",
        }
    },
    paper: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '20px',
        width: '75%'
    },
});

class SeletorEmpresa extends XAPPComponent {

    state = {
        open: false,
        filtro: ""
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.open && !this.state.open) {
            this.handleChange({ target: { name: "filtro", value: "" } });
        }
    }

    getEmpresas = () => {
        const { navigation, sistemas } = this.props;
        const form = this.state;
        let AArray = [];
        Object.keys(sistemas).forEach(key => {
            AArray.push({ id: sistemas[key].idpessoa, title: sistemas[key].nomesocial });
        });
        return AArray;
    }

    openDialog = () => {
        this.setState(_.set({ ...this.state }, "open", !this.state.open));
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };


    render() {
        const { navigation = null, classes, setEmpresa, empresa, children, className } = this.props;
        const form = this.state;
        const AColumns = [
            {
                accessor: "id",
                className: "justify-end"
            },
            {
                accessor: "title",
                className: "justify-dtart"
            }
        ];

        return (
            navigation !== null && Object.keys(navigation).length > 0 &&
            <React.Fragment>
                <div className={clsx("w-full h-full cursor-pointer", className)} onClick={() => this.openDialog()}>
                    {!_.isNull(children) && children}
                </div>
                <XAPPDialog
                    id="SeletorEmpresa"
                    open={form.open}
                    onClose={this.openDialog}
                    fullWidth
                    maxWidth={"sm"}
                > <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {'Selecione uma empresa'}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <IconButton
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                onClick={this.openDialog}
                            >
                                <MdClose className="text-20 text-white" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent>
                        <div className="flex flex-col items-center justify-center py-12">
                            <Paper component="div" className={classes.paper}>
                                <Input
                                    placeholder="Filtrar"
                                    className="flex w-full pl-12 py-4"
                                    disableUnderline
                                    fullWidth
                                    name="filtro"
                                    value={form.filtro}
                                    type='text'
                                    autoComplete="off"
                                    inputProps={{
                                        'aria-label': 'Filtar'
                                    }}
                                    onChange={this.handleChange}
                                />
                            </Paper>
                        </div>
                        <ReactTable
                            className={clsx(classes.root, "min-w-full -striped -highlight border-0")}
                            getTrProps={(state, rowInfo) => {
                                return {
                                    className: rowInfo ? "cursor-pointer" : "",
                                    onClick: () => {
                                        if (rowInfo) {
                                            setEmpresa(rowInfo.original.id);
                                            this.openDialog();
                                            history.push("/home");
                                        }
                                    }
                                }
                            }}
                            data={_.filter(this.getEmpresas(), item => { return item.title.toLowerCase().includes(form.filtro.toLowerCase()) })}
                            columns={AColumns}
                            defaultPageSize={5}
                            showPagination={false}
                            noDataText="Não existem registros cadastrados!"

                        />
                    </DialogContent>
                </XAPPDialog>
            </React.Fragment>
        );
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setEmpresa: FuseActions.setEmpresa,
    }, dispatch);
}


function mapStateToProps({ fuse, auth }) {
    return {
        navigation: fuse.navigation.navigation,
        empresa: fuse.navigation.empresa,
        sistemas: auth.user.data.settings.sistemas,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(SeletorEmpresa)));
